import React, { useContext } from 'react'
import { Box } from '@hub/box'
import { CoreContainer } from '@hub/core-container'
import { Text } from '@hub/text'
import { Portal } from '@hub/portal'
import { LinkContext } from '../../../context'
import { LinkItem, MegaMenuFeature } from '../types'
import { MegaMenuFeaturedItem } from './megamenu-featured-item'
import { MainNavItemWrapper } from './main-nav-item-wrapper'

const isLinkItem = (
  megamenuItem: MegaMenuFeature | LinkItem
): megamenuItem is LinkItem => 'label' in megamenuItem && 'url' in megamenuItem

export const MegaMenu: React.FC<{
  itemId: string
  megaMenuItems?: (MegaMenuFeature | LinkItem)[]
}> = ({ itemId, megaMenuItems }) => {
  const Link = useContext(LinkContext)
  const featuredItemRef = React.useRef<HTMLElement | null>(null)

  return (
    <CoreContainer
      id={itemId}
      sx={{
        fontSize: 'font-sm',
        paddingY: 'spacing-md',
        display: 'flex',
        maxHeight: '440px',
        justifyContent: 'space-between',
      }}
    >
      <Box
        as="ul"
        id={itemId}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          alignContent: 'flex-start',
          flexBasis: '100%',
          overflow: 'hidden',
        }}
      >
        {megaMenuItems &&
          megaMenuItems.map((megamenuItem, i) => (
            <>
              {isLinkItem(megamenuItem) ? (
                <>
                  <MainNavItemWrapper
                    key={`${megamenuItem.url}-${megamenuItem.label}`}
                    sx={{
                      paddingTop: 'spacing-xs',
                      height: 'revert',
                      width: '25%',
                    }}
                  >
                    <Text
                      tone="strong"
                      as={props => <Link {...props} to={megamenuItem.url} />}
                      id={`megamenu-item-${i}`}
                      lineHeight="none"
                    >
                      {megamenuItem.label}
                    </Text>
                    {megamenuItem.megaMenuItems && (
                      <Box as="ul">
                        {megamenuItem.megaMenuItems.map(subItem => (
                          <>
                            {isLinkItem(subItem) && (
                              <MainNavItemWrapper
                                key={`${subItem.url}-${subItem.label}`}
                              >
                                <Link
                                  key={`${subItem.url}-${subItem.label}`}
                                  to={subItem.url}
                                  component={({ children, ...props }) => (
                                    <a {...props}>{children}</a>
                                  )}
                                >
                                  {subItem.label}
                                </Link>
                              </MainNavItemWrapper>
                            )}
                          </>
                        ))}
                      </Box>
                    )}
                  </MainNavItemWrapper>
                </>
              ) : (
                <Portal containerRef={featuredItemRef}>
                  <MegaMenuFeaturedItem feature={megamenuItem} />
                </Portal>
              )}
            </>
          ))}
      </Box>
      <Box ref={featuredItemRef} sx={{ maxWidth: '20%', flexBasis: '20%' }} />
    </CoreContainer>
  )
}
